import React from 'react';
import Intro from '../../components/Homepage/Intro/Intro';
import WhoWeHelp from '../../components/Homepage/WhoWeHelp/WhoWeHelp';
import WhyUs from '../../components/Homepage/WhyUs/WhyUs';

const Index = () => {
	return (
		<div>
			<Intro />
			<WhoWeHelp />
			<WhyUs />
		</div>
	);
};

export default Index;
